/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createBitXor } from '../../factoriesAny.js';
export var bitXorDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createBitXor: createBitXor
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesBitXor.generated.js
// module id = 1357
// module chunks = 0